import React from 'react'
import { Pie } from 'react-chartjs-2'
import {
  Chart as ChartJS,
  ArcElement,
  Tooltip,
  Legend,
} from 'chart.js'
import './ContentTypeChart.scss'

ChartJS.register(ArcElement, Tooltip, Legend)

const ContentTypeChart = ({ statistics }) => {
  if (!statistics) {
    return (
      <div className="content-type-chart">
        <div className="chart-header">
          <h3 className="chart-title">Content Type Distribution</h3>
          <p className="chart-subtitle">No data available</p>
        </div>
      </div>
    )
  }

  const data = {
    labels: ['Free Content', 'Paid Content'],
    datasets: [
      {
        data: [statistics.freeModules, statistics.paidModules],
        backgroundColor: [
          '#3b82f6',
          '#8b5cf6'
        ],
        borderColor: [
          '#2563eb',
          '#7c3aed'
        ],
        borderWidth: 2,
        hoverBackgroundColor: [
          '#60a5fa',
          '#a78bfa'
        ]
      }
    ]
  }

  const options = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: {
        position: 'bottom',
        labels: {
          padding: 20,
          usePointStyle: true,
          font: {
            size: 14,
            weight: '600'
          }
        }
      },
      tooltip: {
        backgroundColor: 'rgba(0, 0, 0, 0.8)',
        titleColor: '#fff',
        bodyColor: '#fff',
        borderColor: '#e5e7eb',
        borderWidth: 1,
        cornerRadius: 8,
        displayColors: true,
        callbacks: {
          label: function(context) {
            const total = context.dataset.data.reduce((a, b) => a + b, 0)
            const percentage = ((context.parsed / total) * 100).toFixed(1)
            return `${context.label}: ${context.parsed} (${percentage}%)`
          }
        }
      }
    }
  }

  return (
    <div className="content-type-chart">
      <div className="chart-header">
        <h3 className="chart-title">Content Type Distribution</h3>
        <p className="chart-subtitle">Free vs Paid modules</p>
      </div>
      <div className="chart-container">
        <Pie data={data} options={options} />
      </div>
      <div className="chart-summary">
        <div className="summary-item">
          <span className="summary-label">Total Modules:</span>
          <span className="summary-value">{statistics.totalModules}</span>
        </div>
        <div className="summary-item">
          <span className="summary-label">Free Content Rate:</span>
          <span className="summary-value">
            {statistics.totalModules > 0 ? ((statistics.freeModules / statistics.totalModules) * 100).toFixed(1) : 0}%
          </span>
        </div>
      </div>
    </div>
  )
}

export default ContentTypeChart
